export default {"src":"/_next/static/image/public/images/download_app_hand_mobile.8f0a2a5bb30023d25a47ebff12fefa7b.svg","height":95,"width":73};